export enum PositionEnum {
  FULL_TIME = 'FULL-TIME',
  PART_TIME = 'PART-TIME',
  SELF_EMPLOYED = 'SELF-EMPLOYED',
  FREELANCE = 'FREELANCE',
  CONTRACT = 'CONTRACT',
  INTERN = 'INTERN',
  APPRENTICESHIP = 'APPRENTICESHIP',
  SEASONAL = 'SEASONAL',
}

export enum LocationEnum {
  REMOTE = 'REMOTE',
  ONSITE = 'ONSITE',
  HYBRID = 'HYBRID',
}

export enum SalaryPeriodEnum {
  PER_MONTH = 'PER_MONTH',
  PER_YEAR = 'PER_YEAR',
}
